import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { HeaderFieldComponent, CellFieldComponent, AttachmentLookupComponent } from '../../common/index';
import { AdminService, MetadataService, AuthService, ApiService, SessionService, ModalService, ConditionService, CalendarService, TranslatorService, FieldService, FormulaService } from '../../../services';
import { ModalComponent } from '../../modal/modal.component';
import { Condition, User } from '../../../models';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
// import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UscStoreMobileComponent } from '../usc-store-mobile.component';
import { UscDialogComponent } from '../../usc-store/usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-table-view',
    templateUrl: './usc-table-view.component.html',
    styleUrls: ['./usc-table-view.component.css']
})
export class UscTableViewComponent extends UscStoreMobileComponent {
    @Input() view: string;
    @Input() scope_type: string = 'channel';
    @Input() scope_value: string = 'Corporate';

    public detail_items: Array<any> = [];
    public filtered_detail_items: Array<any> = [];
    public cur_page_detail_items: Array<any> = [];
    public cur_month_detailed_items: Array<any>;
    public prev_month_detailed_items: Array<any> = [];
    public available_months: Array<any> = [];
    public columnFields: Array<any> = [];
    public visibleColumnFields: Array<any> = [];
    public formulaColumnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    private viewFormulas: Array<any> = [];
    public detail_items_loaded: boolean = false;
    public current_filtered_values: any = {}
    public is_group_label_enabled: boolean = false;
    public columnGroups: any = [];
    public visible_column_groups: any = [];
    public gross_adds_btn_class: string;
    public accessory_btn_class: string;
    // public action_plan_fields: any[];
    public current_month: string;
    public is_current_month: boolean = true;
    public is_previous_month: boolean = false;
    public is_this_month_action_plan: boolean = false;
    public pageFilterFields: Array<any> = [];
    public current_user: User;
    public show_today_sales: boolean = false;
    public is_filtered_to_associate_store: boolean = true;
    public enabled_include_todays_sales: boolean = true;
    public enabled_gross_adds_accs_buttons: boolean = true;
    public enabled_scope_ranking: boolean = true;
    public isPreviousMonthEnabled: boolean = true;
    public max_num_months: number = 12;
    //is_portal_initialized: boolean = false;
    p2wReadySub: Subscription;
    // paging 
    public curPage: number = 1;
    public pageSize: number = 50;
    public pageCount: number = 0;
    public itemCount: number = 0;
    public order_by_field: string = 'total_weighted_pct';
    public asc: boolean = false;
    protected conditionResults: Array<Condition> = [];
    public header_style: any = { 'font-size': '12px', 'font-weight': 'bold', 'color': 'white', 'text-align': 'center' }
    public is_p2w_ready: boolean = false;

    ngOnInit() {
        super.ngOnInit();
        // order of operations
        // 0. determine scope_type and scope_value
        // 1. load metadata to get column_fields and view_conditions
        // 2. load action plans 
        // 3. evaluate view_conditions for each action plan
        // 4. determine viewable columns by column_field's visible/sn_column_visible
        // 5. generate filter data for each filter columns
        this.p2wReadySub = this.uscStoreService.p2wReady.subscribe(r => {
            if (r && !this.is_p2w_ready) {
                this.is_p2w_ready = true;
                this.show_today_sales = false;
                this.current_user = this.authService.getAuth();
                if (this.uscStoreService.isUSCellTelesales()) this.scope_value = 'Telesales';

                // data set scope
                if (this.uscStoreService.isUSCellAgent()) {
                    this.scope_type = 'agency';
                    this.scope_value = this.uscStoreService.getAgencyNameByUser(this.current_user);
                } 
                
                // filtered scoped
                if (this.uscStoreService.isLeader()) {
                    var scope = this.uscStoreService.getDefaultAchievementScopeTeam(this.current_user);
                    this.uscStoreService.setCurrentDetailResultScope(scope);
                }
                this.loadTableViewMetaData();
            }
        });
    }

    getDataView() { return this.view; }

    loadTableViewMetaData() {
        this.detail_items_loaded = false;
        this.visibleColumnFields = [];
        this.columnFields = [];
        var view = this.getDataView();
        this.metadataService.getTableViewMetaData(view, {}, true).subscribe(result => {
            this.columnGroups = result.meta_data.column_groups;
            this.columnFields = result.meta_data.column_fields;
            this.viewConditions = result.meta_data.view_conditions;
            this.viewFormulas = result.meta_data.view_formulas;
            this.pageSize = result.meta_data.view_settings ? result.meta_data.view_settings.page_size : 50;
            
            this.formulaColumnFields = [];
            this.columnFields.forEach(f => {
                if (f.sn_calc_formula && f.sn_calc_formula.length > 0) {
                    this.formulaColumnFields.push(f);
                }
            })

            if (this.enabled_gross_adds_accs_buttons) {
                this.gross_adds_btn_class = this.accessory_btn_class = this.gross_adds_btn_class = this.accessory_btn_class = "";
                switch (this.view) {
                    case this.uscStoreService.view_p2w_goal_gross_adds_detail_results:
                    case this.uscStoreService.view_p2w_quota_gross_adds_detail_results:
                    case this.uscStoreService.view_p2w_associate_gross_adds_detail_results:
                        this.gross_adds_btn_class = "selected";
                        break;
                    case this.uscStoreService.view_p2w_goal_accessory_detail_results:
                    case this.uscStoreService.view_p2w_quota_accessory_detail_results:
                    case this.uscStoreService.view_p2w_associate_accessory_detail_results:
                        this.accessory_btn_class = "selected";
                        break;
                }
            }
            // load view items here after meta data is downloaded
            this.reloadItems();
        });

    }

    getDetailItems(init_filter_fields) {
        if (this.is_current_month) {
            switch (this.view) {
                case this.uscStoreService.view_p2w_goal_gross_adds_detail_results:
                case this.uscStoreService.view_p2w_goal_accessory_detail_results:
                    return this.uscStoreService.getConsultantSalesGoalAchievementByScope(this.scope_type, this.scope_value);
                case this.uscStoreService.view_p2w_associate_gross_adds_detail_results:
                case this.uscStoreService.view_p2w_associate_accessory_detail_results:
                case this.uscStoreService.view_p2w_quota_gross_adds_detail_results:
                case this.uscStoreService.view_p2w_quota_accessory_detail_results:
                    return this.uscStoreService.getConsultantAchievementsByScopeType(this.scope_type, this.scope_value);
            }
        } else {
            var quota_or_goal = this.view.indexOf("_goal_") >= 0 ? "goal" : "quota";
            var detailed_items = this.uscStoreService.getConsultantAchievementsFromPreviousActionPlans(this.current_month, this.scope_type, this.scope_value, quota_or_goal);
            detailed_items.forEach(i => {
                i.new_ur_user_title = this.current_user.title;
                i.new_ur_user_administrator_level = this.current_user.administrator_level;
                i.ur_user_title = this.current_user.title;
                i.ur_user_administrator_level = this.current_user.administrator_level;
            })
            return detailed_items;
        }
    }

    reloadItems(init_filter_fields:boolean = true) {
        // reset state variable before reloading action plans
        this.pageFilterFields = [];
        if (init_filter_fields) {
            this.current_filtered_values = {};
            this.is_filtered_to_associate_store = true;
        } 
        var detail_items = this.getDetailItems(init_filter_fields);
        // certain views need to query db to get the detail_items, thus not all views returns detail_items immediately.
        // for those that does, we can processDetailItems right away. 
        // for those that doesn't, it is up that view to processDetailItems once the detail_items are available.
        if (detail_items) this.processDetailItems(detail_items, init_filter_fields);
    }

    processDetailItems(detail_items, init_filter_fields:boolean) {
        this.detail_items = detail_items;
        // sort items by team alignment ascending order
        if (this.uscStoreService.isUSCellAgent()) {
            this.detail_items.sort(function (a, b) {
                if (a.agency < b.agency) return -1;
                else if (a.store == b.store) return (a.AssociateName < b.AssociateName) ? -1 : 1;
                return 1;
            })
        } else {
            this.detail_items.sort(function (a, b) {
                if (a.region < b.region) return -1;
                else if (a.region == b.region && a.territory < b.territory) return -1;
                else if (a.region == b.region && a.territory == b.territory && a.area < b.area) return -1;
                else if (a.region == b.region && a.territory == b.territory && a.area == b.area && a.store < b.store) return -1;
                else if (a.store == b.store) return (a.AssociateName < b.AssociateName) ? -1 : 1;
                return 1;
            })
        }        
        this.filtered_detail_items = this.detail_items;
        this.detail_items_loaded = true;

        var ur_current_awards = this.columnFields.find(f => f.key == 'ur_current_awards');
        if (ur_current_awards) {
            var awarded_users = this.uscStoreService.awarded_users;
            if (awarded_users && awarded_users.length > 0) {
                this.detail_items.forEach(item => {
                    var user;
                    if (this.view == this.uscStoreService.view_p2w_team_this_action_plans) {
                        user = awarded_users.find(u => u.u_username == item.ur_username);
                    } else {
                        user = awarded_users.find(u => u.u_username == item.CREATOR_ID);
                    }
                    if (user) item.ur_current_awards = user.current_awards;
                })
            }
        }
        
        this.detail_items.forEach(item => {
            item.current_month_subject = this.uscStoreService.getThisMonthActionPlanSubject();
            // process all conditions for each item
            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, null, item);
            }
            if (this.viewFormulas) {
                var formula_results = this.formulaService.calculateFormulaValuesByItem(this.viewFormulas, item);
                this.formulaColumnFields.forEach(f => {
                    var fr = formula_results.find(r => r.name == f.sn_calc_formula);
                    if (fr) item[f.key] = fr.result;
                })
            }
        });

        // extract all visible columns
        this.visibleColumnFields = [];
        this.columnFields.forEach(cf => {
            if (cf.visible) {
                var bVisible = true;
                if (cf.sn_column_visible) {
                    if (cf.sn_column_visible.indexOf('@{') >= 0) {
                        var local_condition = cf.sn_column_visible.replace('@{', '').replace('}', '');
                        bVisible = this[local_condition];
                    } else {
                        var condResult = this.conditionService.getCondition(this.detail_items[0].viewConditions, cf.sn_column_visible);
                        bVisible = condResult ? condResult.result : true;
                    }
                }
                if (bVisible) this.visibleColumnFields.push(cf);
            }

            if (cf.sn_enable_filtering && this.detail_items.length > 0) {
                var condResult = this.conditionService.getCondition(this.detail_items[0].viewConditions, cf.sn_enable_filtering);
                cf.enable_filtering = condResult ? condResult.result : cf.enable_filtering;
            }
            if (cf.is_page_filter && cf.enable_filtering) this.pageFilterFields.push(cf);
        })

        this.visible_column_groups = [];

        // from visible columns, pre-construct grouping <td>
        if (this.visibleColumnFields.find(f => f.group_label != null && f.group_label.length > 0) != null) this.is_group_label_enabled = true;
        if (this.is_group_label_enabled) {
            this.visible_column_groups = [];
            for (var i = 0; i < this.visibleColumnFields.length; i++) {
                var curr_field = this.visibleColumnFields[i];
                var curr_group_label = curr_field.group_label ? curr_field.group_label : '';
                var vg = this.visible_column_groups.find(cg => cg.label == curr_group_label);
                var cg = this.columnGroups ? this.columnGroups.find(cg => cg.label == curr_group_label) : null;
                if (cg) {
                    if (vg == null) {
                        // find the group definition
                        vg = JSON.parse(JSON.stringify(cg));
                        vg.colspan = 1;
                        vg.class = curr_field.cell_class;
                        //g = { label: curr_group_label, colspan: 1, class: curr_field.cell_class }
                        this.visible_column_groups.push(vg);
                    } else {
                        vg.colspan++;
                    }
                }
            }
        }

        // if (this.is_group_label_enabled) {
        //     for (var i = 0; i < this.visibleColumnFields.length; i++) {
        //         var curr_field = this.visibleColumnFields[i];
        //         var curr_group_label = curr_field.group_label ? curr_field.group_label : '';
        //         var g = this.visible_column_groups.find(cg => cg.label == curr_group_label);
        //         if (g != null) {
        //             if (g.initialized) {
        //                 g.colspan++;
        //             } else {
        //                 g.colspan = 1;
        //                 g.class = curr_field.cell_class;
        //                 g.initialized = true;
        //             }
        //             // g = { label: curr_group_label, colspan: 1, class: curr_field.cell_class }
        //             // this.column_groups.push(g);
        //         // } else {
        //         //     g.colspan++;
        //         }
        //     }
        // }

        this.generateFilterData();
        if (init_filter_fields) this.initPageFilterFieldSelections();

        this.curPage = 1;
        this.updateDisplayDetailedItems();
    }

    initPageFilterFieldSelections() {
        var scope = this.uscStoreService.getCurrentDetailResultScope();
        var current_user_scorecard = this.uscStoreService.isLeader() ? this.detail_items.find(i => i[scope.scope_type] == scope.scope_value) : this.detail_items.find(i => i.CREATOR_ID == this.current_user.username);       
        // HACK: initialize page filters based on user's scope_type
        //       agency -> select agency only
        //       region -> select region only
        //       territory => select region and territory
        //       area => select region, territory, and area
        //       store => select region, territory, area, and store
        if (this.uscStoreService.isLeader()) {
            current_user_scorecard = JSON.parse(JSON.stringify(current_user_scorecard));
            switch (scope.scope_type) {
                case "agency": current_user_scorecard.store = null; break;
                case "region": current_user_scorecard.territory = null; // fall through
                case "territory": current_user_scorecard.area = null; // fall through
                case "area": current_user_scorecard.store = null; // fall through
                    break;
            }
        }
        // NOTE: pageFilterField is also a columnField
        this.pageFilterFields.forEach(cf => {
            // initialize filter selection
            if (current_user_scorecard) {
                if (cf.current_filtered_value == null && current_user_scorecard[cf.key]) cf.current_filtered_value = current_user_scorecard[cf.key];
            } else {
                
            }    
        })
    }

    updateDisplayDetailedItems() {
        this.updateFilteredDetailedItems();

        if (this.enabled_scope_ranking) {
            // sort by total_weighted_pct for scope_ranking purpose
            this.filtered_detail_items.sort(function(a, b) {
                return (a.total_weighted_pct > b.total_weighted_pct) ? -1 : 1;
            })

            // apply scope_ranking by the sorted order
            var ranking = 1;
            this.filtered_detail_items.forEach(i => {
                i.sn_scope_ranking = ranking++;
            })
        }

        this.pageCount = Math.ceil(this.filtered_detail_items.length / this.pageSize);
        this.updateCurrentPageDetailedItems();        
    }

    updateFilteredDetailedItems() {
        this.filtered_detail_items = [];
        this.detail_items.forEach(ap => {
            var bInclude = true;
            this.columnFields.forEach(f => {
                if ((f.enable_filtering || f.is_page_filter) && f.current_filtered_value) {
                    bInclude = bInclude && ap[f.key] == f.current_filtered_value;
                }
            })
            if (bInclude) this.filtered_detail_items.push(ap);
        })
        this.generateFilterData();
    }

    updateCurrentPageDetailedItems() {
        var item_index = (this.curPage - 1) * this.pageSize;
        this.cur_page_detail_items = this.filtered_detail_items.slice(item_index, item_index + this.pageSize);
    }

    toggleTodaysSales() {
        this.show_today_sales = !this.show_today_sales;
        this.reloadItems(false);
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.updateCurrentPageDetailedItems();
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.updateCurrentPageDetailedItems();
        }
    }

    onFieldBtnEvent(btnEvent) {
        console.log(btnEvent);
        switch (btnEvent.btn.event) {
            case "sn_open_modal_view": this.openModalView(btnEvent); break;
            case "sn_open_modal_component": this.openModalComponent(btnEvent); break;
        }
    }

    openModalView(btnEvent) {
        var data = [];
        var view = "";
        switch (btnEvent.btn.modal_view) {
            case "view_bfp_form_file_upload":
                data = btnEvent.item;
                view = btnEvent.btn.modal_view;
                break;
        }

        this.modalService.openContent(
            ModalComponent,
            { view: view, data: data },
            { backdrop: 'static', keyboard: false }
        ).result.then((result) => {
            this.sessionService.log(view + ' submitted');
        }, (reason) => {
            this.sessionService.log('Form Closed');
        })
    }

    openModalComponent(btnEvent) {
        switch (btnEvent.btn.modal_component) {
            case "sn-usc-attachment-lookup": this.showAttachments(btnEvent.item); break;
        }
    }

    showAttachments(item) {
        this.modalService.openContent(
            AttachmentLookupComponent,
            { view: this.view, data: item, related_type: "case", related_ID: item.view_ID, title: "Attachments - Claim #" + item.cs_case_number },
            { size: "lg", backdrop: 'static', keyboard: false }
        ).result.then((result) => {
            console.log(result);
        }, (reason) => {
            console.log('Attachment Closed');
        });
    }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.order_by_field ? true : !this.asc;
        this.order_by_field = event.field.key;
        this.setActiveSortColumn(event.field.key);
        this.reloadItems();
    }

    setActiveSortColumn(column_key: string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }

    onFocusOut(action_plan, field) {
    }

    getFieldValueStyle(detail_item, field) {
        var fvc = {};
        if (detail_item && field) {
            var field_value = detail_item[field.key];
            switch (field.key) {
                // quota accessory details
                case "quota_pct_revenue":
                case "quota_pct_accessory_revenue":
                case "quota_pct_other_revenue":
                case "pacing_quota_pct_revenue":
                case "pacing_quota_pct_accessory_revenue":
                case "pacing_quota_pct_other_revenue":
                // quota gross adds details
                case "quota_pct_total_gross_adds":
                case "quota_pct_postpaid_handset_volume":
                case "quota_pct_prepaid":
                case "quota_pct_hsi":
                case "quota_pct_connected_devices":
                case "quota_pct_other_volume":
                case "quota_pct_bir":
                case "pacing_quota_pct_total_gross_adds":
                case "pacing_quota_pct_postpaid_handset_volume":
                case "pacing_quota_prepaid":
                case "pacing_quota_connected_devices":
                case "pacing_quota_pct_prepaid":
                case "pacing_quota_pct_hsi":
                case "pacing_quota_pct_connected_devices":
                case "pacing_quota_pct_other_volume":
                case "pacing_quota_pct_bir":
                case "pacing_quota_pct_upgrades":
                // goal accessory details
                case "goal_pct_revenue":
                case "goal_pct_accessory_revenue":
                case "goal_pct_other_revenue":
                case "pacing_goal_pct_revenue":
                case "pacing_goal_pct_accessory_revenue":
                case "pacing_goal_pct_other_revenue":
                // goal gross adds details
                case "goal_pct_total_gross_adds":
                case "goal_pct_postpaid_handset_volume":
                case "goal_pct_prepaid":
                case "goal_pct_hsi":
                case "goal_pct_connected_devices":
                case "goal_pct_other_volume":
                case "goal_pct_bir":
                case "pacing_goal_pct_total_gross_adds":
                case "pacing_goal_pct_postpaid_handset_volume":
                case "pacing_goal_pct_prepaid":
                case "pacing_goal_pct_hsi":
                case "pacing_goal_pct_connected_devices":
                case "pacing_goal_pct_other_volume":
                case "pacing_goal_pct_bir":
                case "pacing_goal_pct_upgrades":
                    fvc["background-color"] = (Number(field_value) < 1) ? '#fbb4f3' : '#98dca3';
                    break;
                case "mtd_per_box":
                    fvc["background-color"] = (Number(field_value) < 110) ? '#fbb4f3' : '#98dca3';
                    break;
                case "days_scheduled":
                    if (this.is_previous_month) fvc["background-color"] = (Number(field_value) == 0) ? '#fbb4f3' : 'none';
                    break;
            }
        }
        return fvc;
    }

    getMonthDisplayValue(month) { return this.uscStoreService.convertPlanMonth(month); }

    getColumnLabel(field): any {
        if (field) {
            var column_label = field.label;
            if (!this.is_current_month) {
                switch (column_label) {
                    //case "MTD Pacing to Quota": column_label = "Sales vs Quota"; break;
                    //case "MTD Pacing to P2W Goal": column_label = "Sales vs P2W Goal"; break;
                    case "MTD": column_label = "Actual Sales"; break;
                    case "MTD Upgrade": column_label = "Actual Upgrade"; break;
                    case "MTD High MSRP Accessories": column_label = "Actual High MSRP Accessories"; break;
                }
            }
            return column_label;
        }
        return "";
    }

    getFieldValue(detail_item, field): any {
        if (detail_item && field) {
            var field_value = detail_item[field.key];
            switch (field.key) {
                // dp+
                case "dp_attach_rate":
                case "dp_product_mix_pct":
                // quota accessory details
                case "quota_pct_revenue":
                case "quota_pct_accessory_revenue":
                case "quota_pct_other_revenue":
                case "pacing_quota_pct_revenue":
                case "pacing_quota_pct_accessory_revenue":
                case "pacing_quota_pct_other_revenue":
                // quota gross adds details
                case "quota_pct_total_gross_adds":
                case "quota_pct_postpaid_handset_volume":
                case "quota_pct_prepaid":
                case "quota_pct_hsi":
                case "quota_pct_connected_devices":
                case "quota_pct_other_volume":
                case "quota_pct_bir":
                case "pacing_quota_pct_total_gross_adds":
                case "pacing_quota_pct_postpaid_handset_volume":
                case "pacing_quota_prepaid":
                case "pacing_quota_connected_devices":
                case "pacing_quota_pct_prepaid":
                case "pacing_quota_pct_hsi":
                case "pacing_quota_pct_connected_devices":
                case "pacing_quota_pct_other_volume":
                case "pacing_quota_pct_bir":
                case "pacing_quota_pct_upgrades":
                // goal accessory details
                case "goal_pct_revenue":
                case "goal_pct_accessory_revenue":
                case "goal_pct_other_revenue":
                case "pacing_goal_pct_revenue":
                case "pacing_goal_pct_accessory_revenue":
                case "pacing_goal_pct_other_revenue":
                // goal gross adds details
                case "goal_pct_total_gross_adds":
                case "goal_pct_postpaid_handset_volume":
                case "goal_pct_prepaid":
                case "goal_pct_hsi":
                case "goal_pct_connected_devices":
                case "goal_pct_other_volume":
                case "goal_pct_bir":
                case "pacing_goal_pct_total_gross_adds":
                case "pacing_goal_pct_postpaid_handset_volume":
                case "pacing_goal_pct_prepaid":
                case "pacing_goal_pct_hsi":
                case "pacing_goal_pct_connected_devices":
                case "pacing_goal_pct_other_volume":
                case "pacing_goal_pct_bir":
                case "pacing_goal_pct_upgrades":
                // other 
                case "total_weighted_pct":
                    if (field_value == null) field_value = 0;
                    field_value = this.translatorService.toPercentage(field_value);
                    break;
                case "prior_postpaid_handset_volume":
                case "prior_prepaid":
                case "prior_hsi":
                case "prior_cd":
                case "prior_other_volume":
                case "prior_bir":
                case "prior_upgrades":
                case "prior_high_msrp_accessories":
                case "prior_device_trade_ins":
                case "prior_total_gross_adds":
                case "prior_revenue":
                case "prior_accessory_revenue":
                case "prior_other_revenue":
                    if (!this.is_current_month) field_value = "-";
                    else if (field.key.indexOf('revenue') >= 0) field_value = this.translatorService.toCurrency(field_value);
                    break;
                case "mtd_per_box":
                    field_value = this.translatorService.toCurrency(field_value);
                    break;
                case "sn_scope_ranking":
                    if (this.uscStoreService.isUSCellAgent()) {
                        //var ap_id = detail_item.ap_ID;
                        if (detail_item.ap_status != 2 && detail_item.ap_status != -1) field_value = 'N/A';
                    }
                default:
                    if (field.key.indexOf('revenue') >= 0) field_value = this.translatorService.toCurrency(field_value);
                    break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    getButtonTip(field, btn) {
        var btn_tip = btn.button_tip;
        if (!this.is_current_month) btn_tip = "View Action Plan";
        return btn_tip;
    }

    onBtnClick(btn, action_plan, field) {
        switch (btn.event) {
            case "sn_open_action_plan":
                this.gotoActionPlan(btn, action_plan, field); break;
            case "sn_send_ap_reminder":
                this.sendActionPlanReminder(btn, action_plan, field); break;
            case "sn_show_awards":
                const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                modalRef.componentInstance.data = { };
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_user_awards;
                modalRef.componentInstance.msg_config = { current_awards: action_plan.ur_current_awards };
                modalRef.result.then((result) => { }, (reason) => { });
                break;                
        }
    }

    sendActionPlanReminder(btn, action_plan, field) {
        this.modalService.openContent(
            UscDialogComponent,
            { dlgType: this.uscStoreService.dialog_type_action_plan_reminder },
            { backdrop: 'static', keyboard: false }
        ).result.then(
            (result) => {
                var params = { ur_user_ID: action_plan.ur_user_ID };
                var action = this.is_current_month ? this.uscStoreService.action_this_month_ap_reminder : this.uscStoreService.action_next_month_ap_reminder;
                this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, action_plan.view_ID, action, params).subscribe(
                    result => {
                        this.sessionService.log("action plan reminder sent");
                    }
                )
            },
            (reason) => { }
        );
    }

    gotoActionPlan(btn, action_plan, field) {
        if (action_plan.ur_title == 'Store' || action_plan.ur_title == 'Assistant Manager') {
            if (action_plan.view_ID == null) {
                let dlg = this.showCustomPromptDlg({ }, { msg: "Loading Action Plan" });
                var ap_view = (this.view == this.uscStoreService.view_p2w_team_this_action_plans) ? this.uscStoreService.action_get_this_month_action_plan : this.uscStoreService.action_get_next_month_action_plan;
                var params = (action_plan.ur_title == "Store") ? { user_ID: action_plan.ur_user_ID } : null;
                this.uscStoreService.processActionOnViewItems(this.uscStoreService.view_p2w_action_plan, ap_view, params).subscribe(result => { 
                    dlg.dismiss();
                    this.navigateToActionPlan(result.data);
                    // this.uscStoreService.setActionPlan(result.data);
                });
            } else {
                this.navigateToActionPlan(action_plan);
                // this.uscStoreService.setActionPlan(action_plan);
            }
        } else if (action_plan.view_ID > 0) {
            this.navigateToActionPlan(action_plan);
            // this.uscStoreService.setActionPlan(action_plan);
        } 
    }

    navigateToActionPlan(ap) {
        var url_format = '/usc-store-mobile/mobile-action-plan-table?item_ID=_ID_&view=_VIEW_';
        var url = url_format.replace('_ID_', ap.view_ID.toString());

        if (ap) {
            var ap_subject = ap.cs_subject;
            if (ap.ap_subject != null && ap.ap_subject.length > 0) ap_subject = ap.ap_subject;
            if (ap_subject == this.uscStoreService.getThisMonthActionPlanSubject()) {
                url = url.replace('_VIEW_', this.uscStoreService.view_p2w_this_action_plan);
            } else if (ap_subject == this.uscStoreService.getNextMonthActionPlanSubject()) {
                url = url.replace('_VIEW_', this.uscStoreService.view_p2w_next_action_plan);
            } else {
                url = url.replace('_VIEW_', this.uscStoreService.view_p2w_prev_action_plan);
            }
        }        
        this.router.navigateByUrl(url);
    }

    showCustomPromptDlg(item, msg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    isAllowEdit(item, field) {
        if (field.sn_allow_edit) {
            var condResult = this.conditionService.getCondition(item.viewConditions, field.sn_allow_edit);
            return condResult ? condResult.result : true;
        }
        return field.allow_edit;
    }

    isValueVisible(item, field) {
        return true;
    }

    isBtnVisible(btn, item, field) {
        if (item && item.viewConditions) {
            var condResult = this.conditionService.getCondition(item.viewConditions, btn.sn_visible);
            return condResult ? condResult.result : true;
        }
        return true;
    }

    isColumnVisible(column) {
        switch (column.key) {
            default:
                return column.visible;
        }
    }

    isImageIcon(btn) { return (btn.button_type == "IMG"); }
    isFontAwesomeIcon(btn) { return (btn.button_type != "IMG"); }

    //#region Data Filters
    generateFilterData() {
        this.columnFields.forEach(f => {
            if (f.enable_filtering && (f.filter_data == null || f.is_dataset_dependent_filter != false)) f.filter_data = this.getDataFilter(f);
        })
    }

    getDataFilter(field) {
        var filter_list = !field.allow_all_as_filter_value ? [] : [{ label: 'All', value: '' }];
        if (this.detail_items_loaded && field.enable_filtering) {
            if (field.filter_data_source == 'data') {
                this.filtered_detail_items.forEach(ap => {
                    var field_value = this.getFieldValue(ap, field);
                    var filter = filter_list.find(f => f.value == field_value);
                    if (filter == null) {
                        var field_label = this.getFieldFilterDisplay(ap, field);
                        filter_list.push({ label: field_label, value: field_value });
                    }
                })
            }
            filter_list.sort(function (a, b) {
                var sort_order = -1; // default: ascending order
                if (field.filter_value_sort_order == 'desc') sort_order = 1;
                return (a.value < b.value) ? sort_order : sort_order * -1;
            })
        }
        return filter_list;
    }

    getFieldFilterDisplay(item, field): any {
        if (item && field) {
            return this.getFieldValue(item, field);
        }
        return null;
    }

    showFilteredValue(field): boolean {
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return true;
        return (field && field.current_filtered_value);
    }

    getFilteredValue(field) {
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return 'All';
        return field.current_filtered_value;
    }

    filter(field, f) {
        this.curPage = 1;
        field.current_filtered_value = (f.value == 'All' || f.value == '') ? null : f.value;
        this.updateDisplayDetailedItems();
    }
    //#endregion

    onSort(event, field) {
        this.curPage = 1;
        this.asc = (this.order_by_field == field.key) ? !this.asc : false;
        this.order_by_field = field.key;
        var sort_order = this.asc;
        // apply actual sort order
        this.filtered_detail_items.sort(function(a, b) {
            var order = a[field.key] < b[field.key] ? -1 : 1;
            return sort_order ? order : order * -1;
        })
        
        this.updateCurrentPageDetailedItems();        
    }

    showGrossAdds() {
        switch (this.view) {
            case this.uscStoreService.view_p2w_goal_accessory_detail_results:
                this.view = this.uscStoreService.view_p2w_goal_gross_adds_detail_results;
                this.loadTableViewMetaData();
                break;
            case this.uscStoreService.view_p2w_quota_accessory_detail_results:
                this.view = this.uscStoreService.view_p2w_quota_gross_adds_detail_results;
                this.loadTableViewMetaData();
                break;
            case this.uscStoreService.view_p2w_associate_accessory_detail_results:
                this.view = this.uscStoreService.view_p2w_associate_gross_adds_detail_results;
                this.loadTableViewMetaData();
                break;
        }
    }

    showAccessory() {
        switch (this.view) {
            case this.uscStoreService.view_p2w_goal_gross_adds_detail_results:
                this.view = this.uscStoreService.view_p2w_goal_accessory_detail_results;
                this.loadTableViewMetaData();
                break;
            case this.uscStoreService.view_p2w_quota_gross_adds_detail_results:
                this.view = this.uscStoreService.view_p2w_quota_accessory_detail_results;
                this.loadTableViewMetaData();
                break;
            case this.uscStoreService.view_p2w_associate_gross_adds_detail_results:
                this.view = this.uscStoreService.view_p2w_associate_accessory_detail_results;
                this.loadTableViewMetaData();
                break;
        }
    }

    hasTextToolTip(field) {
        return (field && field.tooltip && field.tooltip.length > 0);
    }

    hasHtmlToolTip(obj) {
        return (obj && obj.html_tooltip && obj.html_tooltip.length > 0);
    }

    getFieldTextToolTip(item, field) {
        if (this.hasTextToolTip(field) && item.tooltip == null) {
            item.tooltip = this.translatorService.translate(null, item, field.tooltip);
        }
        return item.tooltip;
    }

    getFieldHtmlToolTip(item, obj) {
        var html_tooltip;
        if (this.hasHtmlToolTip(obj)) {
            if (item && item.html_tooltip == null) {
                item.html_tooltip = this.translatorService.translate(null, item, obj.html_tooltip);
            } 
            html_tooltip = item ? item.html_tooltip : obj.html_tooltip;
        }
        return html_tooltip;
    }

    ngOnDestroy() {
        if (this.p2wReadySub) this.p2wReadySub.unsubscribe();
    }

    getViewStyle() {
        var style:any = { }
        var vs = this.sessionService.getQueryVariable("vs");
        if (vs) style = JSON.parse(vs);
        return style;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-table-view/usc-table-view.component.ts